// src/business-types/saloon/modules/home/hooks/OrderService.ts
import { buildOrderData } from "../utils/orderHelpers";
import { StylingStaff, SelectProduct } from "../types/salon.types";
import { getLedgerByCustomer, postOrder } from "src/shared/services/servicesv2";

interface Customer {
  Name: string;
  phone_number: string;
}

interface Payment {
  method: string;
  received: number;
  isFullPayment: boolean;
}

interface Totals {
  subtotal: number;
  total: number;
}

export interface CompleteOrderParams {
  customerId: string;
  staff: StylingStaff | null;
  products: SelectProduct[];
  totals: Totals;
  customer: Customer;
  payment: Payment;
  paymentHistory: Payment;
  discount: number; // ✅ keep number in UI
  tips: string;
  time: any; // ✅ accept any (instead of TimeState)
  outstandingBalance: number;
}

/** -------- Fetch outstanding balance -------- */
export const fetchOutstandingBalance = async (customerId: string): Promise<number> => {
  try {
    const { data } = await getLedgerByCustomer(customerId);
    return Number(data.ledger?.totalOutstandingBalance || 0);
  } catch (err) {
    console.error("Error fetching ledger", err);
    return 0;
  }
};

/** -------- Complete order -------- */
export const completeOrder = async (params: CompleteOrderParams) => {
  // ✅ Convert discount to string for buildOrderData
  const orderData = buildOrderData({
    ...params,
    discount: String(params.discount),
  });

  const { data } = await postOrder(orderData)
  // api.post("/app/pos/v2/order", orderData);

  return { data, orderData };
};
